<template>
  <div class="header whole-bgt" id="headerMenu">
    <div class="head_box flex-center flex_zBetween">
      <div class="head_l flex-center">
        <div class="head-time flex-center">
          <p>{{ `${weather.weather} ${weather.temperature}℃` }}</p>
          <i :class="iconCondition" style=""></i>
          <!-- <img src="../assets/images/tq.png" alt=""> -->
        </div>
        <div class="head-nav flex-center">
          <div class="nav-item">
            <router-link to="/Screen">返回大屏</router-link>
          </div>
          <div :class="activeDetail ? 'nav-item active' : 'nav-item'">
            <router-link to="/Details">产业概况</router-link>
          </div>
          <div :class="activePolicy ? 'nav-item active' : 'nav-item'">
            <router-link to="/Policy">政策法规</router-link>
          </div>
        </div>
      </div>
      <div class="head-tt">
        <p @click="handleIndexMap()" style="cursor:pointer">
          红寺堡区农业产业数字化服务平台
        </p>
      </div>
      <div class="head_r flex-center">
        <div class="head-nav flex-center">
          <div :class="activeVideo ? 'nav-item active' : 'nav-item'">
            <router-link to="/Video">视频中心</router-link>
          </div>
          <div :class="activeCenter ? 'nav-item active' : 'nav-item'">
            <router-link to="/Center">数据中心</router-link>
          </div>
          <div class="nav-item">
            <router-link to="" @click.native="hanleManageClick()"
              >管理入口</router-link
            >
          </div>
        </div>
        <div class="head-r flex-center">
          <el-menu class="el-menu-demo" mode="horizontal" text-color="#ffffff">
            <el-submenu index="2">
              <template slot="title">欢迎您！</template>
              <el-menu-item index="2-1" @click="handleLoginOut()"
                >退出登录</el-menu-item
              >
            </el-submenu>
          </el-menu>

          <!--					<div class="head-icon flex-center"><img src="../assets/images/user.png" alt="">-->
          <!--						<p>欢迎您！</p>-->
          <!--					</div>-->
          <!--					<p class="head-return" @click="handleLoginOut()" style="cursor: pointer;">退出登录</p>-->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import axios from "axios";
export default {
  props: {
    active: {
      type: String,
      default: "Detail",
    },
  },
  data() {
    return {
      activeDetail: false,
      activePolicy: false,
      activeVideo: false,
      activeCenter: false,
      weather: {}, //用于存放天气相关的数据
      iconCondition: null, //icon
      userInfo: null,
    };
  },
  computed: {
    ...mapState(["Authorization"]),
  },
  created() {
    this.userInfo = this.Authorization;
    this.getWether();
  },
  mounted() {
    this.handleRouterClick(this.active);
  },
  destroyed() {},
  methods: {
    async getWether() {
      try {
        const { data } = await axios.get(
          `https://restapi.amap.com/v3/weather/weatherInfo?key=7952f0543749fe21298320bc5c58ccdf&city=640303`
        );
        console.log("天气", data);

        // 添加错误处理，检查API返回状态
        if (data.status === '0' || !data.lives || data.lives.length === 0) {
          console.warn("天气API返回异常", data);
          // 使用默认天气数据
          this.weather = {
            weather: '未知',
            temperature: '--'
          };
          this.iconCondition = 'iconfont icon-tianqi';
        } else {
          // 正常情况
          this.weather = data.lives[0];
          this.iconCondition = this.setWeatherIcon(data.lives[0]?.weather);
        }
      } catch (error) {
        console.error("获取天气信息失败:", error);
        // 请求失败时使用默认数据
        this.weather = {
          weather: '未知',
          temperature: '--'
        };
        this.iconCondition = 'iconfont icon-tianqi';
      }
    },
    // 设置icon
    setWeatherIcon(weather) {
      // 处理了基础的天气
      if (weather === "晴") {
        return "iconfont icon-lieri";
      } else if (weather.includes("云")) {
        return "iconfont icon-duoyun";
      } else if (weather.includes("风")) {
        return "iconfont icon-feng";
      } else if (weather.includes("雨")) {
        return "iconfont icon-dayu";
      } else if (weather.includes("雪")) {
        return "iconfont icon-zhongxue";
      } else if (weather.includes("雾")) {
        return "iconfont icon-wuqi";
      }
      return "iconfont icon-tianqi";
    },
    handleIndexMap() {
      this.$router.push({ name: "Index" });
    },
    hanleManageClick() {
      // let account = localStorage.getItem("account");
      // let password = localStorage.getItem("password");
      //   let url =
      //     "http://10.10.10.221:8990?account = " +
      //     account +
      //     "&password=" +
      // 		password;
      let url =
        // "http://10.10.10.221:8990?account=" + account + "&password=" + password;
          "https://farm.nxnycy.cn/admin"
      //   window.open(window.ADMIN_URL, "_blank");
      window.open(url, "_blank");
    },
    handleRouterClick(value) {
      if (value === "Details") {
        (this.activeDetail = true),
          (this.activePolicy = false),
          (this.activeVideo = false),
          (this.activeCenter = false);
      } else if (value === "Policy") {
        (this.activeDetail = false),
          (this.activePolicy = true),
          (this.activeVideo = false),
          (this.activeCenter = false);
      } else if (value === "Video") {
        (this.activeDetail = false),
          (this.activePolicy = false),
          (this.activeVideo = true),
          (this.activeCenter = false);
      } else if (value === "Center") {
        (this.activeDetail = false),
          (this.activePolicy = false),
          (this.activeVideo = false),
          (this.activeCenter = true);
      }
    },
    handleLoginOut() {
      const _this = this;
      this.$api.login
        .postLoginout()
        .then((res) => {
          if (res.code == 200) {
            _this.Authorization = "";
            localStorage.removeItem("Authorization");
            _this.$router.push("/Login");
            this.$message({
              message: "退出成功！",
              type: "success",
            });
          } else {
            this.$message({
              message: res.message,
              type: "warning",
            });
          }
        })
        .catch((error) => {
          console.log("error", error);
        });
    },
  },
};
</script>
<style scoped>
.header {
  background-image: url("../assets/images/nei-hd.png");
  background-size: 100% 100%;
  background-repeat: no-repeat;
  height: 110px;
  color: #ffffff;
  padding: 0 20px;
  font-size: 14px;
  position: relative;
  z-index: 2;
}

.head_box {
  height: 100%;
  position: relative;
}

.head-time {
  display: flex;
  align-items: center;
  //border: 1px solid red;
  margin-top: -7.5%;
  width: 25%;
}
.head-time p {
  text-align: right;
  min-width: 85px;
}
.head-time .iconfont {
  width: 44px;
  font-size: 22px;
  margin-left: 10px;
  margin-right: 36px;
}

.head-tt span {
  background-image: -webkit-linear-gradient(bottom, #b9e4ff, #ffffff);
  background-clip: text;
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
}

.head-icon img {
  width: 36px;
  height: 36px;
  margin-left: 10px;
}

.head-icon p {
  color: #659ae7;
  margin: 0 5px 0 10px;
}

.head-return {
  color: #cce1ff;
}

.nav-item {
  border: 1px solid #006afa;
  width: 114px;
  height: 34px;
  margin-left: 14px;
  transform: skewX(22deg);
}

.nav-item a {
  transform: skewX(-22deg);
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 18px;
  font-weight: bold;
}

.nav-item.active,
.nav-item:hover {
  background: linear-gradient(to bottom, #4760ff, #0dccff);
}

.head-nav {
  margin-top: -7.3%;
  width: 75%;
}

.head_l {
  z-index: 100;
  width: 30%;
  height: 100%;
}
.head_l .head-nav {
  justify-content: flex-end;
  margin-right: 5%;
}

.head-tt {
  font-size: 2.5rem;
  font-weight: bold;
  width: 40%;
  height: 100%;
  left: 0;
  text-align: center;
  z-index: 99;
  display: flex;
  align-items: center;
  justify-content: center;
}
.head-tt p {
  margin-top: -3%;
}

.head_r {
  z-index: 100;
  width: 30%;
  height: 100%;
}
.head_r .nav-item {
  transform: skewX(-22deg);
  margin-left: 0;
  margin-right: 14px;
}
.head_r .head-nav {
  margin-left: 5%;
}

.head_r .nav-item a {
  transform: skewX(22deg);
}
</style>

<style>
#headerMenu .head-r {
  height: 100%;
}
#headerMenu .el-menu-demo {
  background-color: rgba(0, 0, 0, 0);
  height: 100%;
  border: none;
  margin-top: 8%;
}
#headerMenu .el-menu-demo .el-submenu__title:hover {
  background: rgba(0, 0, 0, 0) !important;
  color: #16bcff !important;
}
#headerMenu .el-menu-demo .el-submenu__title:hover .el-submenu__icon-arrow {
  color: #16bcff !important;
}

#headerMenu .el-menu-demo .el-submenu__icon-arrow {
  color: #ffffff;
}

.el-menu--horizontal .el-menu {
  background-color: rgba(0, 0, 0, 0) !important;
  min-width: 115px;
}

.el-menu--horizontal .el-menu .el-menu-item {
  background-color: rgba(7, 90, 192, 0.35) !important;
  text-align: center;
}
</style>
